import React, { useState, useContext } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaLock, FaUser, FaEye, FaEyeSlash } from 'react-icons/fa';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import Logo from '../assets/logo.png'; // Adjust the path if needed
import { AlertContext } from '../contexts/AlertContext';
import { BASE_URL } from '../config';
import axios from 'axios';
import Swal from 'sweetalert2';
import ReCaptchaComponent from '../components/ReCaptchaComponent';
// import { useGoogleLogin } from '@react-oauth/google';

const Login = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    rememberMe: false
  });
  const [isLoading, setIsLoading] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  // const [googleUser, setGoogleUser] = useState(null);
  const { showAlert } = useContext(AlertContext);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}/login`, {
        username: formData.username,
        password: formData.password,
        rememberMe: formData.rememberMe,
        recaptchaToken
      });
      const result = response.data;
      if (response.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Login Successful',
          text: 'Welcome back to AllAccess!',
          timer: 1500,
          showConfirmButton: false,
          background: '#ffffff',
          customClass: {
            popup: 'rounded-2xl shadow-xl',
            title: 'text-slate-800 font-semibold',
            content: 'text-slate-600'
          }
        });
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('authentication/token', result.access_token);
        localStorage.setItem('authentication/expire', result.expires_in);
        localStorage.setItem('authentication/scopes', result.scope);
        localStorage.setItem('authentication/refresh_token', result.refresh_token);
        localStorage.setItem('authentication/token_type', result.token_type);
        localStorage.setItem('authentication/permissions', JSON.stringify(result.permissions));
        window.location.reload();
      }
    } catch (error) {
      if (error.response) {
        const result = error.response.data;
        if (result.error === 'invalid_recaptcha') {
          Swal.fire({
            icon: 'error',
            title: 'reCAPTCHA Failed',
            text: 'The reCAPTCHA verification failed. Please refresh your browser.',
            background: '#ffffff',
            customClass: {
              popup: 'rounded-2xl shadow-xl',
              title: 'text-slate-800 font-semibold',
              content: 'text-slate-600'
            }
          });
        } else {
          const errorMessage = typeof result.message === 'object'
            ? Object.values(result.message).flat().join(', ')
            : result.message || 'Invalid credentials';
          Swal.fire({
            icon: 'error',
            title: 'Login Failed',
            text: errorMessage,
            background: '#ffffff',
            customClass: {
              popup: 'rounded-2xl shadow-xl',
              title: 'text-slate-800 font-semibold',
              content: 'text-slate-600'
            }
          });
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Connection Error',
          text: 'Connection error. Please try again.',
          background: '#ffffff',
          customClass: {
            popup: 'rounded-2xl shadow-xl',
            title: 'text-slate-800 font-semibold',
            content: 'text-slate-600'
          }
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  // const googleLogin = useGoogleLogin({
  //   onSuccess: (tokenResponse) => {
  //     setGoogleUser(tokenResponse);
  //     setIsLoading(true);
  //   },
  //   onError: () => {
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Google Login Failed',
  //       text: 'Google Login failed. Please try again.',
  //       background: '#ffffff',
  //       customClass: {
  //         popup: 'rounded-2xl shadow-xl',
  //         title: 'text-slate-800 font-semibold',
  //         content: 'text-slate-600'
  //       }
  //     });
  //     setIsLoading(false);
  //   },
  // });

  // useEffect(() => {
  //   if (googleUser) {
  //     const googleAccessToken = googleUser.access_token;
  //     const handleGoogleLoginSubmit = async () => {
  //       setIsLoading(true);
  //       try {
  //         const response = await axios.post(`${BASE_URL}/google-login`, {
  //           username: formData.username,
  //           password: formData.password,
  //           rememberMe: formData.rememberMe,
  //           recaptchaToken,
  //           googleAccessToken
  //         });
  //         const result = response.data;
  //         if (response.status === 200) {
  //           Swal.fire({
  //             icon: 'success',
  //             title: 'Login Successful',
  //             text: 'Welcome back to AllAccess!',
  //             timer: 1500,
  //             showConfirmButton: false,
  //             background: '#ffffff',
  //             customClass: {
  //               popup: 'rounded-2xl shadow-xl',
  //               title: 'text-slate-800 font-semibold',
  //               content: 'text-slate-600'
  //             }
  //           });
  //           localStorage.setItem('isLoggedIn', 'true');
  //           localStorage.setItem('authentication/token', result.access_token);
  //           localStorage.setItem('authentication/expire', result.expires_in);
  //           localStorage.setItem('authentication/scopes', result.scope);
  //           localStorage.setItem('authentication/refresh_token', result.refresh_token);
  //           localStorage.setItem('authentication/token_type', result.token_type);
  //           localStorage.setItem('authentication/permissions', JSON.stringify(result.permissions));
  //           window.location.reload();
  //         }
  //       } catch (error) {
  //         if (error.response) {
  //           const result = error.response.data;
  //           const errorMessage = typeof result.message === 'object'
  //             ? Object.values(result.message).flat().join(', ')
  //             : result.message || 'Invalid credentials';
  //           Swal.fire({
  //             icon: 'error',
  //             title: 'Login Failed',
  //             text: errorMessage,
  //             background: '#ffffff',
  //             customClass: {
  //               popup: 'rounded-2xl shadow-xl',
  //               title: 'text-slate-800 font-semibold',
  //               content: 'text-slate-600'
  //             }
  //           });
  //         } else {
  //           Swal.fire({
  //             icon: 'error',
  //             title: 'Connection Error',
  //             text: 'Connection error. Please try again.',
  //             background: '#ffffff',
  //             customClass: {
  //               popup: 'rounded-2xl shadow-xl',
  //               title: 'text-slate-800 font-semibold',
  //               content: 'text-slate-600'
  //             }
  //           });
  //         }
  //       } finally {
  //         setIsLoading(false);
  //       }
  //     };
  //     handleGoogleLoginSubmit();
  //   }
  // }, [googleUser]);

  const handleFacebookLogin = () => {
    Swal.fire({
      icon: 'error',
      title: 'Not Implemented',
      text: 'Facebook login is not yet implemented.',
      background: '#ffffff',
      customClass: {
        popup: 'rounded-2xl shadow-xl',
        title: 'text-slate-800 font-semibold',
        content: 'text-slate-600'
      }
    });
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        when: 'beforeChildren',
        staggerChildren: 0.1
      }
    }
  };

  const childVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-emerald-50 flex items-center justify-center p-4">
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />
      <div className="pointer-events-none fixed inset-0 -z-10 opacity-40">
        <div className="absolute -top-32 -right-32 h-96 w-96 bg-gradient-to-br from-blue-200 to-cyan-200 rounded-full blur-3xl animate-pulse-slow" />
        <div className="absolute -bottom-32 -left-32 h-96 w-96 bg-gradient-to-br from-emerald-200 to-teal-200 rounded-full blur-3xl animate-pulse-slow" />
      </div>
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="w-full max-w-md bg-white/95 backdrop-blur-md rounded-2xl shadow-2xl p-8 border border-slate-200"
      >
        <motion.div variants={childVariants} className="text-center mb-8">
          <img
            src={Logo}
            alt="AllAccess Logo"
            className="mx-auto h-16 w-auto mb-4 transition-transform duration-300 hover:scale-105"
          />
          <h1 className="text-2xl font-bold text-slate-800 tracking-tight">
            Sign in to AllAccess
          </h1>
          <p className="text-sm text-slate-500 mt-2">
            Secure access to your HMO dashboard
          </p>
        </motion.div>
        <form onSubmit={handleSubmit}>
          <motion.div variants={childVariants} className="mb-6">
            <label className="block text-slate-700 text-sm font-semibold mb-2">
              Username or Email
            </label>
            <div className="relative">
              <FaUser className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleInputChange}
                disabled={isLoading}
                className="w-full pl-12 pr-4 py-3 rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent bg-white/80 transition-all duration-300 disabled:bg-slate-100 disabled:cursor-not-allowed"
                placeholder="Enter username or email"
                required
              />
            </div>
          </motion.div>
          <motion.div variants={childVariants} className="mb-6">
            <label className="block text-slate-700 text-sm font-semibold mb-2">
              Password
            </label>
            <div className="relative">
              <FaLock className="absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
              <input
                type={showPassword ? 'text' : 'password'}
                name="password"
                value={formData.password}
                onChange={handleInputChange}
                disabled={isLoading}
                className="w-full pl-12 pr-12 py-3 rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent bg-white/80 transition-all duration-300 disabled:bg-slate-100 disabled:cursor-not-allowed"
                placeholder="Enter password"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(prev => !prev)}
                className="absolute right-3 top-1/2 -translate-y-1/2 p-1 text-slate-500 hover:text-slate-700 transition-colors duration-200"
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? (
                  <FaEyeSlash className="h-4 w-4" />
                ) : (
                  <FaEye className="h-4 w-4" />
                )}
              </button>
            </div>
          </motion.div>
          <motion.div variants={childVariants} className="flex items-center justify-between mb-6">
            <div className="flex items-center">
              <input
                type="checkbox"
                name="rememberMe"
                checked={formData.rememberMe}
                onChange={handleInputChange}
                className="w-4 h-4 text-emerald-600 rounded border-slate-300 focus:ring-emerald-500"
              />
              <label className="ml-2 text-sm text-slate-600">Remember me for 2 weeks</label>
            </div>
            <Link
              to="/forgot-password"
              className="text-sm text-emerald-600 hover:text-emerald-700 hover:underline transition-colors duration-300"
            >
              Forgot password?
            </Link>
          </motion.div>
          <motion.button
            variants={childVariants}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            type="submit"
            disabled={isLoading}
            className="w-full bg-gradient-to-r from-emerald-600 to-teal-600 text-white py-3 rounded-lg font-semibold hover:from-emerald-700 hover:to-teal-700 transition-all duration-300 flex items-center justify-center gap-2 shadow-sm hover:shadow-md disabled:bg-slate-400 disabled:cursor-not-allowed"
          >
            {isLoading ? (
              <>
                <FontAwesomeIcon icon={faSpinner} className="animate-spin" />
                Authenticating...
              </>
            ) : (
              'Sign In'
            )}
          </motion.button>
        </form>
        {/* <motion.div variants={childVariants} className="relative my-6">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-slate-300"></div>
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="px-3 bg-white/95 text-slate-600">Or continue with</span>
          </div>
        </motion.div>
        <motion.div variants={childVariants} className="space-y-3">
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => googleLogin()}
            disabled={isLoading}
            className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-lg font-semibold hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 flex items-center justify-center gap-2 shadow-sm hover:shadow-md disabled:bg-slate-400 disabled:cursor-not-allowed"
          >
            <FaGoogle />
            Sign in with Google
          </motion.button>
        </motion.div> */}
        <motion.div variants={childVariants} className="mt-6">
          <ReCaptchaComponent onTokenReceived={setRecaptchaToken} />
        </motion.div>
        <motion.div variants={childVariants} className="mt-6 text-center">
          {/* <p className="text-sm text-slate-600">
            Don't have an account?{' '}
            <Link
              to="/register"
              className="text-emerald-600 font-semibold hover:text-emerald-700 hover:underline transition-colors duration-300"
            >
              Create an AllAccess account
            </Link>
          </p> */}
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Login;
